import React, { useEffect } from "react";
import { Navigate, Route } from "react-router-dom";
import { setAuthorization } from "../helpers/api_helper";
import { useDispatch } from "react-redux";
import { logoutUser } from "../slices/thunks";
import AuthService from "../admin/components/login/AuthService";

const AuthProtected = ({ children, allowedTypes }) => {
  const dispatch = useDispatch();
  const userData =   AuthService.getUserData();
  const token = AuthService.getToken();

  useEffect(() => {
    if (userData) {
      setAuthorization(token);
    } else if (!userData && !token) {
      dispatch(logoutUser());
    }
  }, [token, userData, dispatch]);

  // Se o usuário não estiver autenticado, redireciona para login
  if (!userData && !token) {
    return <Navigate to={{ pathname: "/login" }} />;
  }

  // Verifica se o usuário tem permissão para acessar a rota

  const userType = userData?.users_type_id;
  if (allowedTypes?.length > 0 && !allowedTypes.includes(userType)) {
    return <Navigate to="/admin/unauthorized" />;
  }

  return <>{children}</>;
};

// Componente para aplicar `AuthProtected` diretamente em rotas
const AccessRoute = ({ component: Component, allowedTypes, ...rest }) => {
  return (
      <Route
          {...rest}
          element={
            <AuthProtected allowedTypes={allowedTypes}>
              <Component />
            </AuthProtected>
          }
      />
  );
};

export { AuthProtected, AccessRoute };
